// extracted by mini-css-extract-plugin
export default {"Link":"Pry8pTBMy0gpfSbVUujA"};